import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=6ad11e61&"
import script from "./Ticker.vue?vue&type=script&lang=js&"
export * from "./Ticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports